import { RequestBuilder } from "../requestBuilder";
import { GetTenantsResponseSchema, SwitchProjectInputSchema } from "./tenantsClient.types";

export const GetTenantsRequestConfig = new RequestBuilder({
  path: () => "/tenants",
  responseSchema: GetTenantsResponseSchema,
});

export const SwitchProjectRequestConfig = new RequestBuilder({
  path: () => "/switch-project",
  bodySchema: SwitchProjectInputSchema,
}).withMethod("POST");
